type Chain = {
	Name: string;
	ImageUrl: string;
	Url: string;
	Preformatted?: boolean;
	GSId?: number;
};

const imgEndpoint = 'https://cdn.polaris.me/img/';

const Chains = new Map<string, Chain>([
	[
		'bakers',
		{
			// prettier-ignore
			Name: 'Baker\'s',
			ImageUrl: `${imgEndpoint}bakers-square-logo.png`,
			Url: 'https://www.bakersplus.com',
			Preformatted: true,
			GSId: 76,
		},
	],
	[
		'citymarket',
		{
			Name: 'City Market',
			ImageUrl: `${imgEndpoint}city-market-square-logo.png`,
			Url: 'https://www.citymarket.com',
			Preformatted: true,
			GSId: 301,
		},
	],
	[
		'copps',
		{
			Name: 'Copps',
			ImageUrl: `${imgEndpoint}kroger-square-logo.png`,
			Url: 'https://www.picknsave.com',
			Preformatted: true,
			GSId: 1063,
		},
	],
	[
		'dillons',
		{
			Name: 'Dillon Food Store',
			ImageUrl: `${imgEndpoint}dillons-square-logo.png`,
			Url: 'https://www.dillons.com',
			Preformatted: true,
			GSId: 440,
		},
	],
	[
		'food4less',
		{
			Name: 'Food 4 Less',
			ImageUrl: `${imgEndpoint}food-for-less-square-logo.png`,
			Url: 'https://www.food4less.com',
			Preformatted: true,
			GSId: 573,
		},
	],
	[
		'foodsco',
		{
			Name: 'Foods Co',
			ImageUrl: `${imgEndpoint}foodsco-square-logo.png`,
			Url: 'https://www.foodsco.net',
			Preformatted: true,
			//GSId: 629,
		},
	],
	[
		'fredmeyer',
		{
			Name: 'Fred Meyer',
			ImageUrl: `${imgEndpoint}fred-meyer-square-logo.png`,
			Url: 'https://www.fredmeyer.com',
			Preformatted: true,
			GSId: 650,
		},
	],
	[
		'frys',
		{
			// prettier-ignore
			Name: 'Fry\'s Food & Drug Store',
			ImageUrl: `${imgEndpoint}frys-square-logo.png`,
			Url: 'https://www.frysfood.com',
			Preformatted: true,
			GSId: 674,
		},
	],
	[
		'gerbes',
		{
			Name: 'Gerbes',
			ImageUrl: `${imgEndpoint}gerbes-square-logo.png`,
			Url: 'https://www.gerbes.com',
			Preformatted: true,
			GSId: 706,
		},
	],
	[
		'hart',
		{
			Name: 'Harris Teeter',
			ImageUrl:
				'https://crud-cdn.polaris.me/assets/images/55dd2435-626d-492b-9165-07d22067ee59/300',
			Url: 'https://www.harristeeter.com',
			Preformatted: true,
			//GSId: 826,
		},
	],
	[
		'jayc',
		{
			Name: 'Jay C Food Store',
			ImageUrl: `${imgEndpoint}jayc-food-store-square-logo.png`,
			Url: 'https://www.jaycfoods.com',
			Preformatted: true,
			GSId: 964,
		},
	],
	[
		'kingsoopers',
		{
			Name: 'King Soopers',
			ImageUrl: `${imgEndpoint}king-sooper-square-logo.png`,
			Url: 'https://www.kingsoopers.com',
			Preformatted: true,
			GSId: 1044,
		},
	],
	[
		'kroger',
		{
			Name: 'Kroger',
			ImageUrl: `${imgEndpoint}kroger-square-logo.png`,
			Url: 'https://www.kroger.com',
			Preformatted: true,
			GSId: 1063,
		},
	],
	[
		'marianos',
		{
			// prettier-ignore
			Name: 'Mariano\'s Fresh Market',
			ImageUrl: `${imgEndpoint}marianos-square-logo.png`,
			Url: 'https://www.marianos.com',
			Preformatted: true,
			//GSId: 1190,
		},
	],
	[
		'metromarket',
		{
			Name: 'Metro Market',
			ImageUrl: `${imgEndpoint}metro-market-square-logo.png`,
			Url: 'https://www.metromarket.net',
			Preformatted: true,
			//GSId: 1265,
		},
	],
	[
		'owens',
		{
			// prettier-ignore
			Name: 'Owen\'s',
			ImageUrl: `${imgEndpoint}kroger-square-logo.png`,
			Url: 'https://www.kroger.com',
			Preformatted: true,
		},
	],
	[
		'payless',
		{
			Name: 'Pay-Less Super Markets',
			ImageUrl: `${imgEndpoint}pay-less-super-markets-square-logo.png`,
			Url: 'https://www.pay-less.com',
			Preformatted: true,
			//GSId: 1426,
		},
	],
	[
		'picknsave',
		{
			// prettier-ignore
			Name: 'Pick \'n Save',
			ImageUrl: `${imgEndpoint}pick-n-save-square-logo.png`,
			Url: 'https://www.picknsave.com',
			Preformatted: true,
			GSId: 1447,
		},
	],
	[
		'qfc',
		{
			Name: 'QFC',
			ImageUrl: `${imgEndpoint}qfc-square-logo.png`,
			Url: 'https://www.qfc.com',
			Preformatted: true,
			GSId: 1560,
		},
	],
	[
		'ralphs',
		{
			Name: 'Ralphs',
			ImageUrl: `${imgEndpoint}ralphs-square-logo.png`,
			Url: 'https://www.ralphs.com',
			Preformatted: true,
			GSId: 1579,
		},
	],
	[
		'ruler',
		{
			Name: 'Ruler Foods',
			ImageUrl: `${imgEndpoint}ruler-foods-square-logo.png`,
			Url: 'https://rulerfoods.com',
			Preformatted: true,
			GSId: 4678,
		},
	],
	[
		'smiths',
		{
			// prettier-ignore
			Name: 'Smith\'s Food & Drug Center',
			ImageUrl: `${imgEndpoint}smiths-square-logo.png`,
			Url: 'https://www.smithsfoodanddrug.com',
			Preformatted: true,
			GSId: 1851,
		},
	],
]);

const chainNames = (): string[] => {
	const names = new Set<string>();
	Chains.forEach((v) => {
		names.add(v.Name);
	});
	return Array.from(names);
};

const getChainKeyByName = (name: string): string => {
	let chainKey = '';
	Chains.forEach((value, key) => {
		if (value.Name === name) {
			chainKey = key
		}
	})
	return chainKey;
}

export { Chain, Chains, chainNames, getChainKeyByName };
